import React, { useEffect, useRef } from "react";
import Media from "../../components/common/Media";
import Link from "../../components/Link";
import { styled } from "../../stitches.config";
import TruncatText from "../atoms/TruncatText";
import CategoryBadge from "../CategoryBadge";
import { bodyLarge, h3 } from "../commonStyles/Fonts";

import ResizableContainer from "../../helpers/ResizableContainer"

export interface IArticleListItem {
  title: string;
  lead: string;
  url: string;
  categoryName?: string;
  picture?: any;
  fullWidth?: boolean;
  truncatLength?: number;
  date?: string;
}

const isDesktop = window.innerWidth > 996;

const ArticleListItem: React.FC<IArticleListItem> = ({
  title,
  lead,
  url,
  categoryName,
  picture,
  fullWidth,
  truncatLength,
  date,
}) => {
  return (
    <Link to={url}>
      <Wrapper type={fullWidth ? "fullWidth" : undefined}>
        {picture && (
          <ImageWrapper>
            <Media
              src={picture.img}
              alt={picture.alt}
              height={picture.height}
              width={picture.width}
              media={picture.media}
            />
            {categoryName && (
              <BadgeWrapper>
                <CategoryBadge text={categoryName} />
              </BadgeWrapper>
            )}
          </ImageWrapper>
        )}
        {isDesktop ?
          <TextWrapper>
            <Title className={h3()}>{title}</Title>
            <Lead className={bodyLarge()}>
              <TruncatText text={lead} maxLength={truncatLength || 162} />
            </Lead>
            {date && <Date className={bodyLarge()}>{date}</Date>}
          </TextWrapper>
          :
          <TextMobileWrapper className={bodyLarge()}>
            <ResizableContainer content={title} />
          </TextMobileWrapper>
        }
      </Wrapper>
    </Link>
  );
};

const Wrapper = styled("div", {
  display: "flex",
  "@bp4": {
    display: "grid",
    gridTemplateColumns: "1fr 3fr",
    gap: "24px",
  },
  variants: {
    type: {
      fullWidth: {
        display: "flex",
        width: "100%",
      },
    },
  },
});

const ImageWrapper = styled("div", {
  position: "relative",
  width: "108px",
  flexShrink: "0",
  "@bp4": {
    width: "300px",
    height: "200px",
  },
  "& img": {
    width: "100%",
    objectFit: "cover",
  },
});

// const Image = styled(Media, {
//   objectFit: "fill",
//   width: "100%",
//   "@bp4": {
//     width: "300px",
//     height: "200px",
//   },
// });

const BadgeWrapper = styled("span", {
  display: "none",
  "@bp4": {
    display: "block",
    position: "absolute",
    bottom: "16px",
    left: "16px",
    zIndex: 3,
  },
});

const TextWrapper = styled("div", {
  color: "$grayscale100",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

const TextMobileWrapper = styled("div", {
  color: "$grayscale100",
  fontWeight: "600",
  maxHeight: "72px",
  overflow: "hidden",
  marginLeft: "16px",
});


const Title = styled("h4", {
  padding: 0,
  margin: 0,
  fontFamily: "$grotesk",
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: "0px",
  fontWeight: "600",
  "@bp4": {
    fontSize: 24,
    lineHeight: "30px",
    letterSpacing: "0.2px",
    fontWeight: "700",
  },
});

const Lead = styled("p", {
  display: "none",
  "@bp4": {
    display: "block",
    padding: 0,
    margin: "8px 0 0 0",
  },
});

const Date = styled("span", {
  display: "block",
  paddingTop: "16px",
});

export default ArticleListItem;
